export default {"src":"/_next/static/media/lemon-logo.9a94c45f.svg","height":32,"width":112,"blurWidth":0,"blurHeight":0};